<template>
  <m-geo-box geo-option="multiCount">
    <m-suppression-select-item
      :configData="configData"
      :suppressions="suppressionItems"
    ></m-suppression-select-item>
  </m-geo-box>
</template>

<script>
import MSuppressionSelectItem from "@/components/demo/MSuppressionSelectItem.vue";
import MGeoBox from "@/components/geo/MGeoBox";
export default {
  components: {
    MSuppressionSelectItem,
    MGeoBox,
  },
  data() {
    return {
      configData: {
        itemTitle: "Your Saved Count List",
        selectedTitle: "Saved Counts Selected",
        getItemUrl: "PlaceOrder.aspx/GetSaveCountSuppressionList",
        addItemKey: "order/addGeo",
        removeItemKey: "order/deleteGeo",
        clearItemsKey: "OrderGeos",
        searchText1: "Saved Count Name",
        searchText2: "Saved Count Number ",
        isShowAddAll: false,
        itemTitle1: "Count Date",
        itemTitle2: "Count Number",
        itemTitle3: "Count Name",
        selectItemTitle1: "Count Number",
        selectItemTitle2: "Count Name",
        isGeoSLC: true,
      },
    };
  },
  computed: {
    suppressionItems() {
      let result = [];
      for (let item of this.$store.getters["order/geoItems"]) {
        result.push({
          name: item.GeoKeyDesc,
          code: item.GeoKeyCode,
          GeoKeyCode: item.GeoKeyCode,
        });
      }
      return result;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/order/GeoSLCCount.vue